import { render, staticRenderFns } from "./ModalCreditUser.vue?vue&type=template&id=1f48dad4&scoped=true&"
import script from "./ModalCreditUser.vue?vue&type=script&lang=js&"
export * from "./ModalCreditUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreditUser.vue?vue&type=style&index=0&id=1f48dad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48dad4",
  null
  
)

export default component.exports